export const toPercent = (ratio: number): number => {
    if (isFinite(ratio)) {
        return ratio * 100
    } else {
        return 0
    }
}
